/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'WeatherRecord',dictionary:{"de":{"references":{"projectTimeReport":"Baustellenbericht","weather":"Wetter"},"times":{"start":"Start","end":"Ende"},"isAdverse":"Schlechtwetter","remark":"Anmerkung"}}})
import { Login } from './Login';
import { ProjectTimeReport } from './ProjectTimeReport';
import { Weather } from './Weather';

export class WeatherRecord extends _BaseModel {
	
	static toString() {
		return 'WeatherRecord'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WeatherRecord.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WeatherRecord', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WeatherRecord.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WeatherRecord', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WeatherRecord.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WeatherRecord', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WeatherRecord', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WeatherRecord', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WeatherRecord.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WeatherRecord', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WeatherRecord'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WeatherRecord) || _BaseModel.t('rules.reference', {modelName:'WeatherRecord', path:'meta.currentDocument'}) ],
				model: WeatherRecord,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WeatherRecord', path:'meta.revisions'}) ],
				model: WeatherRecord,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	projectTimeReport:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ProjectTimeReport'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WeatherRecord', path:'references.projectTimeReport'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ProjectTimeReport) || _BaseModel.t('rules.reference', {modelName:'WeatherRecord', path:'references.projectTimeReport'}) ],
				model: ProjectTimeReport,
				returnObject: true,
},
    
	},
	
					
	weather:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Weather'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WeatherRecord', path:'references.weather'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Weather) || _BaseModel.t('rules.reference', {modelName:'WeatherRecord', path:'references.weather'}) ],
				model: Weather,
				returnObject: true,
},
    
	},
	
},
			times: 				{
					
	start:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WeatherRecord.times.start'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WeatherRecord', path:'times.start'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WeatherRecord', path:'times.start'}) ],
},
    
	},
	
					
	end:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WeatherRecord.times.end'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WeatherRecord', path:'times.end'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WeatherRecord', path:'times.end'}) ],
},
    
	},
	
},
				
	temparature:{
		type: 'number',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WeatherRecord.temparature'),
				rules: [ (value)=> (value === undefined || value === null || typeof +value === 'number') || _BaseModel.t('rules.type.number', {modelName:'WeatherRecord', path:'temparature'}) ],
},
    
	},
	
				
	remark:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.WeatherRecord.remark'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'WeatherRecord', path:'remark'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WeatherRecord._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, times={}, temparature='', remark='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.times=TimesClass.create(times);
		this.temparature=temparature;
		this.remark=remark;
		this._id=_id;
	}

	static create(data) {
		return new WeatherRecord(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof WeatherRecord || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : WeatherRecord.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof WeatherRecord ? item : WeatherRecord.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({projectTimeReport=undefined, weather=undefined, }={}){
		this.projectTimeReport= (projectTimeReport instanceof ProjectTimeReport || typeof projectTimeReport === 'string' || !projectTimeReport) ? projectTimeReport : ProjectTimeReport.create(projectTimeReport);
		this.weather= (weather instanceof Weather || typeof weather === 'string' || !weather) ? weather : Weather.create(weather);
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class TimesClass {
	constructor({start=undefined, end=undefined, }={}){
		this.start=start;
		this.end=end;
	}

	static create(data) {
		return new TimesClass(data);
	}
}
